import clsx from 'clsx';
import { useRef } from 'react';
import { Swiper, SwiperSlide, SwiperRef } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import type { DatePeriod, Link as LinkType } from '@trg/api';
import { useEventsVisibiity } from '../../hooks';
import { EventItem } from './EventItem';

export type EventText = DatePeriod & LinkType & { mainHeading: string };

export interface EventAdProps {
  events?: EventText[];
}

export function Events({ events = [] }: EventAdProps) {
  const swiperRef = useRef<SwiperRef>(null);

  const isVisible = useEventsVisibiity();

  if (isVisible) {
    swiperRef.current?.swiper.autoplay.resume();
  } else {
    swiperRef.current?.swiper.autoplay.pause();
  }

  return (
    <div
      className={clsx(
        '-tlw-z-1 tlw-absolute tlw-top-full tlw-w-full tlw-h-12 tlw-bg-white tlw-duration-300 tlw-origin-top tlw-overflow-hidden',
        isVisible ? 'tlw-translate-y-0' : '-tlw-translate-y-full'
      )}
    >
      <Swiper
        className="tlw-w-[360px] tlw-h-full tlw-mx-auto tlw-select-none"
        modules={[Autoplay]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        speed={600}
        grabCursor
        loop
      >
        {events.map(({ mainHeading, link, linkTarget }) => (
          <SwiperSlide
            key={link}
            className="tlw-flex tlw-justify-center tlw-items-center"
          >
            <EventItem href={link} target={linkTarget}>
              {mainHeading}
            </EventItem>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
